export const Shadows = {
    dialog: '0px 8px 12px 0px #0000001A',
    snackbar: '0px 8px 12px 0px #0000001A',
}